import { SliderBlogs } from '@/component/Slider';
import { ShowBlog } from '@/query';

import { usePostsSlider } from './usePostsSlider';

export const LocationPosts = (props) => {
  const { called, posts, handleNext, loading, metadata } = usePostsSlider({
    placement: props.blog,
    query: ShowBlog,
    isBlog: true,
  });

  return called && posts?.length ? (
    <SliderBlogs
      classesHeader="md:max-lg:pt-[46px] lg:!pt-16"
      classesSlider="lg:!pb-24"
      items={posts}
      onLoadMore={handleNext}
      loading={loading}
      hasNextPage={metadata.hasNextPage}
      widthLarge
      title={metadata.title}
      {...props}
    />
  ) : null;
};
